import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "../keys";
import { getNotifications } from "../../../services/notifications";
import { WSNotificationResponse } from "../../../modules/Dashboard/components/Notifications";

export const useQueryNotifications = (
  queryConfig?: WSQueryConfig<WSNotificationResponse[], unknown>
) =>
  useWSQuery(QUERY_NOTIFICATIONS_NOTIFICATIONS, getNotifications, {
    ...queryConfig
  });
